import { transferOrderStatuses } from '../transfer-order-statuses';

const PERMISSIONS = {
  OPEN: 'open',
  EDIT: 'edit',
  RECEIVE: 'receive',
  CLOSE: 'close',
  CANCEL: 'cancel',
} as const;

type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

const PERMISSION_MATRIX: Record<string, Permission[]> = {
  [transferOrderStatuses.draft]: [PERMISSIONS.OPEN, PERMISSIONS.EDIT, PERMISSIONS.CANCEL],
  [transferOrderStatuses.open]: [PERMISSIONS.EDIT, PERMISSIONS.RECEIVE, PERMISSIONS.CANCEL],
  [transferOrderStatuses.receiving]: [PERMISSIONS.RECEIVE],
  [transferOrderStatuses.received]: [PERMISSIONS.CLOSE],
  [transferOrderStatuses.closed]: [],
  [transferOrderStatuses.cancelled]: [],
};

const hasPermission = (status: string, permission: Permission): boolean => {
  if (!status || typeof status !== 'string') {
    return false;
  }

  const allowedPermissions = PERMISSION_MATRIX[status];
  return Array.isArray(allowedPermissions) && allowedPermissions.includes(permission);
};

export const canOpenTransferOrder = (status: string): boolean => {
  return hasPermission(status, PERMISSIONS.OPEN);
};

export const canEditTransferOrder = (status: string): boolean => {
  return hasPermission(status, PERMISSIONS.EDIT);
};

export const canReceiveTransferOrder = (status: string): boolean => {
  return hasPermission(status, PERMISSIONS.RECEIVE);
};

export const canCloseTransferOrder = (status: string): boolean => {
  return hasPermission(status, PERMISSIONS.CLOSE);
};

export const canCancelTransferOrder = (status: string): boolean => {
  return hasPermission(status, PERMISSIONS.CANCEL);
};

export const hasAvailableActions = (status: string): boolean => {
  return canEditTransferOrder(status) || canCancelTransferOrder(status);
};
